export const PASSWORD_CHANGE_RECAPTCHA_ACTION = "password_change";
